import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Impacter } from '../../models/impacter/impacter';

@Injectable({
  providedIn: 'root'
})
export class EntityService {
  private entityId = new Subject<string | null>();
  private articleIMTotalCount = new Subject<number | null>();
  private articleIMCurrentCount = new Subject<number | null>();
  private document = new Subject<object>();
  private impacter = new Subject<Impacter | null>();
  private bookMarkPathsSubject = new Subject<{id: string, bookmarkPaths: Array<any>}>();
  contentRef: Element | null = document.querySelector('.root-content');

  sendEntityId(entityId: string | null): void {
    this.entityId.next(entityId);
  }

  getEntityId(): Observable<string | null> {
    return this.entityId.asObservable();
  }

  sendArticleIMTotalCount(totalCount: number | null): void {
    this.articleIMTotalCount.next(totalCount);
  }

  sendArticleIMCurrentCount(totalCount: number | null): void {
    this.articleIMCurrentCount.next(totalCount);
  }

  getArticleIMTotalCount(): Observable<number | null> {
    return this.articleIMTotalCount.asObservable();
  }

  getArticleIMCurrentCount(): Observable<number | null> {
    return this.articleIMCurrentCount.asObservable();
  }

  sendDocument(doc: object | null | undefined): void {
    if (this.contentRef) {
      if (doc) {
        this.contentRef.classList.add('full-height');
      } else {
        this.contentRef.classList.remove('full-height');
      }
    }
    if(doc){
      this.document.next(doc);
    }
  }

  sendImpacter(impacter: Impacter | null): void {
    this.impacter.next(impacter);
  }

  sendBookmarkPaths(id: string, bookmarkPaths: Array<any>) {
    this.bookMarkPathsSubject.next({id: id, bookmarkPaths: bookmarkPaths});
  }

  getDocument(): Observable<object> {
    return this.document.asObservable();
  }

  getImpacter(): Observable<Impacter | null> {
    return this.impacter.asObservable();
  }

  get BookMarkPathsSubject(): Observable<{id: string, bookmarkPaths: Array<any>}> {
    return this.bookMarkPathsSubject;
  }
}
